import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fromLocalInput } from "@/lib/api";
import { Modal } from "@/components/ui-bits";
import { CoachSelect } from "@/components/CoachSelect";


export const SessionForm = ({ clientId, defaultDate, onClose, onSaved }) => {
  const [clients, setClients] = useState([]);
  const [f, setF] = useState({ clientId: clientId || "", startAt: defaultDate ? `${defaultDate}T07:00` : "", title: "Training Session", focus: "", status: "AWAITING_CONFIRMATION", trainerId: null });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  useEffect(() => {
    api.get("/clients").then((r) => { setClients(r.data); if (!clientId && r.data[0]) setF((x) => ({ ...x, clientId: r.data[0].id })); });
  }, [clientId]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/sessions", { ...f, startAt: fromLocalInput(f.startAt), focus: f.focus || null });
      toast.success("Session added");
      onSaved();
    } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };

  return (
    <Modal title="ADD SESSION" sub="Manually book a slot. It lands in the client's portal for confirmation." onClose={onClose} testId="session-form-modal">
      <form onSubmit={save}>
        <label>Client</label>
        <select value={f.clientId} onChange={set("clientId")} disabled={!!clientId} data-testid="session-client-select">
          {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <div className="frow">
          <div><label>Start (gym time)</label><input type="datetime-local" required value={f.startAt} onChange={set("startAt")} data-testid="session-start-input" /></div>
          <div><label>Status</label>
            <select value={f.status} onChange={set("status")} data-testid="session-status-select">
              <option value="AWAITING_CONFIRMATION">Awaiting confirmation</option><option value="CONFIRMED">Confirmed</option>
            </select></div>
          <CoachSelect label="Coach" value={f.trainerId} onChange={(v) => setF({ ...f, trainerId: v })} testId="session-coach-select" />
        </div>
        <div className="frow">
          <div><label>Title</label><input value={f.title} onChange={set("title")} data-testid="session-title-input" /></div>
          <div><label>Focus</label><input placeholder="Lower body power" value={f.focus} onChange={set("focus")} data-testid="session-focus-input" /></div>
        </div>
        <div className="mfoot">
          <button type="button" className="btn g" onClick={onClose} data-testid="session-form-cancel">Cancel</button>
          <button className="btn" disabled={busy || !f.clientId} data-testid="session-form-save">Book it</button>
        </div>
      </form>
    </Modal>
  );
};
